import { jsx as _jsx } from "react/jsx-runtime";
import { get } from "lodash";
import { renderToString } from "react-dom/server";
import { isQueryChoicesNode, isStaticChoicesNode, } from "@reside/forms";
import { makeFormattedRenderer } from "../helpers";
const RAW_LABEL_CHOICE_IDS = new Set(["includeInAuditYes"]);
export const getChoices = (reference, queryVariables, translateLabel) => {
    // TODO: the hack guard messes with the next guards in if below, Typescript issue, so we cast to ANY
    const hackReference = reference;
    if (isQueryChoicesNode(hackReference)) {
        return get(queryVariables, hackReference.query.path, []);
    }
    if (isStaticChoicesNode(reference)) {
        const { choices = [] } = reference;
        return choices.map(choice => ({
            value: choice.id,
            label: RAW_LABEL_CHOICE_IDS.has(choice.id)
                ? choice.translationKey
                : translateLabel(choice.translationKey),
            children: choice.children,
        }));
    }
};
// Escape markdown special characters to prevent them from being interpreted as formatting
export const escapeMarkdown = (value) => {
    if (typeof value === "string") {
        return value.replace(/([*_`~#[\]\\])/g, "\\$1");
    }
    return value;
};
// Escape all string values in an object, returns original if no escaping needed
export const escapeMarkdownInObject = (obj) => {
    const MARKDOWN_CHARS = /[*_`~#[\]\\]/;
    // Check if any string value needs escaping
    const keys = Object.keys(obj);
    const needsEscape = keys.some(key => typeof obj[key] === "string" && MARKDOWN_CHARS.test(obj[key]));
    if (!needsEscape) {
        return obj;
    }
    const result = {};
    for (const key of keys) {
        result[key] = escapeMarkdown(obj[key]);
    }
    return result;
};
// LIMITATION: query can be max 1 level deep
export const getCustomOptionLabel = (reference, option, translate) => {
    const { id, ...labelFields } = option;
    const labelPattern = reference.optionLabel
        ? translate(reference.optionLabel.translationKey)
        : Object.keys(labelFields)
            .map(key => `[[query.${reference.query.path}.${key}]]`)
            .join(" ");
    // Escape markdown chars in option values to preserve literal characters like *
    const escapedOption = escapeMarkdownInObject(option);
    const FormattedRenderer = makeFormattedRenderer({
        query: {
            [reference.query.path]: escapedOption,
        },
    });
    const htmlString = renderToString(_jsx(FormattedRenderer, { translation: labelPattern }));
    // Match any wrapper tag (span, p, div, etc.) with data-reactroot attribute.
    // Use [\s\S]*? to handle multiline content (e.g., when Markdown renders <p> for newlines).
    // Fallback: if React output changes (e.g., data-reactroot removed), strip tags from full htmlString.
    const LABEL_PATTERN = /<(\w+) data-reactroot="">([\s\S]*?)<\/\1>/;
    const match = LABEL_PATTERN.exec(htmlString);
    const captured = match?.[2] ?? htmlString;
    // Strip any remaining HTML tags from captured content (e.g., <li> from list items)
    const stripped = captured.replace(/<[^>]+>/g, "").trim();
    const label = stripped || option.name || String(option.id);
    return label;
};
// Return as an element to enable markdown syntax (italic, bold, etc)
export const getCustomOptionLabelAsElement = (reference, option, translate) => {
    const { id, ...labelFields } = option;
    const labelPattern = reference.optionLabel
        ? translate(reference.optionLabel.translationKey)
        : Object.keys(labelFields)
            .map(key => `[[query.${reference.query.path}.${key}]]`)
            .join(" ");
    const FormattedRenderer = makeFormattedRenderer({
        query: {
            [reference.query.path]: option,
        },
    });
    return _jsx(FormattedRenderer, { translation: labelPattern });
};
